.teamsList {
    padding-top: 1rem;
    padding-bottom: 1rem;
}